import React, { useState, useEffect } from 'react';
import './GlobalSearch.css';
import { API_URL } from '../config';

interface SearchResult {
  type: 'commune' | 'road' | 'section';
  id: number;
  name: string;
  parent?: string;
  roadId?: number;
}

interface GlobalSearchProps {
  onNavigate: (type: string, id: number, roadId?: number) => void;
}

const GlobalSearch: React.FC<GlobalSearchProps> = ({ onNavigate }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<SearchResult[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (query.length < 2) {
      setResults([]);
      return;
    }

    const searchTimeout = setTimeout(async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/search?q=${encodeURIComponent(query)}`);
        const data = await response.json();
        setResults(data);
      } catch (error) {
        console.error('Search error:', error);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(searchTimeout);
  }, [query]);

  const handleSelect = (result: SearchResult) => {
    onNavigate(result.type, result.id, result.roadId);
    setQuery('');
    setResults([]);
    setIsOpen(false);
  };

  return (
    <div className="global-search">
      <div className="search-input-container">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Rechercher commune, route, tronçon..."
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
          className="global-search-input"
        />
        {query && (
          <button className="clear-search-btn" onClick={() => setQuery('')}>✕</button>
        )}
      </div>

      {isOpen && query.length >= 2 && (
        <div className="search-results">
          {loading ? (
            <div className="search-loading">Recherche...</div>
          ) : results.length > 0 ? (
            results.map((result, index) => (
              <div
                key={index}
                className={`search-result-item ${result.type}`}
                onClick={() => handleSelect(result)}
              >
                <span className="result-icon">
                  {result.type === 'commune' ? '🏘️' : result.type === 'road' ? '🛣️' : '📏'}
                </span>
                <div className="result-content">
                  <div className="result-name">{result.name}</div>
                  {result.parent && <div className="result-parent">{result.parent}</div>}
                </div>
                <span className="result-arrow">→</span>
              </div>
            ))
          ) : (
            <div className="no-results">Aucun résultat pour "{query}"</div>
          )}
        </div>
      )}
    </div>
  );
};

export default GlobalSearch;
